import React from "react"
import autobind from "class-autobind"
import { Checkbox } from "material-ui"
import strings from "../../../localization/strings"
import { IDate } from "../../../models"
import moment from "moment"

interface IProps {
  isScheduleTemplate: boolean
  // it's local time
  scheduleStartDate: IDate
  dayLength: number
  selectedDay: number
  // when clone, we need to exclude the selectedDay
  excludeSelectedDay: boolean
  handleSelectDays(selectedDays: number[]): void
}
interface IState {
  selectedDays: number[]
}

export default class ShiftSelectDays extends React.Component<IProps, IState> {
  private allDayArray: number[] = []
  constructor(props: IProps) {
    super(props)
    this.state = {
      selectedDays: props.excludeSelectedDay ? [] : [props.selectedDay],
    }
    for (let i = 0; i < props.dayLength; i++) {
      this.allDayArray.push(i)
    }
    autobind(this)
  }

  handleSelectDays(selectedDays) {
    this.setState({ selectedDays })
    this.props.handleSelectDays &&
      this.props.handleSelectDays(selectedDays)
  }

  render() {
    return (
      <div>
        <Checkbox
          data-intercom-target={"AddShifts-CheckBox-SelectAll"}
          label={strings.SelectAll}
          style={{ width: 100 }}
          labelStyle={{ width: null }}
          iconStyle={{ marginRight: 5 }}
          checked={this.state.selectedDays.length === (this.props.excludeSelectedDay ? this.props.dayLength - 1 : this.props.dayLength)}
          onCheck={(e, value) => this.handleSelectDays(
            this.props.excludeSelectedDay ?
              value ? this.allDayArray.filter(item => item !== this.props.selectedDay) : [] :
              value ? this.allDayArray : [this.props.selectedDay]
          )}
        />
        {new Array(Math.ceil(this.props.dayLength / 7)).fill("").map((divRow, divIndex) =>
          <div key={divIndex}>
            {new Array(7).fill("").map((row, index) => {
              const dayIndex = divIndex * 7 + index
              return dayIndex < this.props.dayLength &&
                <Checkbox
                  data-intercom-target={`AddShifts-CheckBox-SelectDay${index + 1}`}
                  key={dayIndex}
                  checked={this.state.selectedDays.includes(dayIndex)}
                  disabled={this.props.selectedDay === dayIndex}
                  label={this.props.isScheduleTemplate ?
                    (strings.formatString(strings.Day_X, dayIndex + 1) as string).trim() :
                    moment(this.props.scheduleStartDate).add(dayIndex, "day").format("ddd DD")
                  }
                  onCheck={(e, checked) => {
                    let selectedDays = this.state.selectedDays.slice()
                    if (checked) {
                      !selectedDays.includes(dayIndex) && selectedDays.push(dayIndex)
                    }
                    else {
                      selectedDays = selectedDays.filter(item => item !== dayIndex)
                    }
                    this.handleSelectDays(selectedDays)
                  }}
                  iconStyle={{ marginRight: 5 }}
                  style={{ width: 85, marginRight: 10, display: "inline-block" }}
                  labelStyle={{ width: null }}
                />
            })}
          </div>
        )}
      </div>
    )
  }
}
